<template>
    <div class="page-content" id="identification-form">
        <Titlebar :incrustation="'fa-id-card'" :backPath="'/parameters/identifications'">
            <h1>{{ pageTitle }}</h1>
        </Titlebar>
        <div class="row align-items-center justify-content-center full-height">
            <div class="col-12 col-lg-6 d-flex justify-content-center">
                <IDCard :imageLink="identification.picture" :serial="identification.serial" :title="identification.name" :comment="identification.comment"></IDCard>
            </div>
            <div class="col-12 col-lg-6">
                <UiCard>
                    <form class="form p-0">
                        <div class="form-row row">
                            <label class="col-4">{{ $t('identification.serial') }}</label>
                            <input type="text" class="form-input col" v-model="identification.serial" name="serial" v-validate
                                data-vv-rules="required" :data-vv-as="$t('identification.serial')"/>
                            <span class="form-input-error" v-show="showErrors['serial'] && errors.has('serial')"
                                @click="hideError('serial')">{{ errors.first('serial') }}</span>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('identification.name') }}</label>
                            <input type="text" class="form-input col" v-model="identification.name" name="name" v-validate
                                data-vv-rules="required" :data-vv-as="$t('identification.name')"/>
                            <span class="form-input-error" v-show="showErrors['name'] && errors.has('name')"
                                @click="hideError('name')">{{ errors.first('name') }}</span>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('identification.language') }}</label>
                            <select class="form-input col"  v-model="identification.language">
                                <option value="null">Aucune</option>
                                <option v-for="(lang,key) in languages" :value="key">{{ lang }}</option>
                            </select>
                            <span class="form-input-error" v-show="showErrors['language'] && errors.has('language')"
                                @click="hideError('language')">{{ errors.first('language') }}</span>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">
                            {{ $t('identification.comment') }}
                            <span style="position: relative;margin-left: 10px;">
                                        <i class="fa fa-question-circle text-warning warning-beepiz-remote-monitoring show"></i>
                                        <div class="tooltip left" style="width: 250px;top: -2px; left: 37px;">
                                        <h5 style="color:#ffc107; font-weight:700">{{ $t('identification.tooltip.title') }}</h5>
                                        {{ $t('identification.tooltip.content') }}
                                        </div>
                                </span>
                            </label>
                            <textarea class="form-input col" v-model="identification.comment"></textarea>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('identification.photo') }}</label>
                            <PhotoInput
                                    id="IDPhoto"
                                    ref="IDPhoto"
                                    class="square"
                                    accept="image/jpeg,image/png,image/gif"
                                    margin="0"
                                    width="200"
                                    height="200"
                                    size="1"
                                    buttonClass="action-button"
                                    removeButtonClass="action-button"
                                    :crop="true"
                                    :removable="true"
                                    :customStrings="{
                                        upload: $t('global.form.pictureinput.upload'),
                                        drag: '<img src=\''+userPlaceholder+'\'/>',
                                        tap: $t('global.form.pictureinput.tap'),
                                        change: $t('global.form.pictureinput.change'),
                                        remove: $t('global.form.pictureinput.remove'),
                                        select: $t('global.form.pictureinput.select'),
                                        selected: $t('global.form.pictureinput.selected'),
                                        fileSize: $t('global.form.pictureinput.fileSize'),
                                        fileType: $t('global.form.pictureinput.fileType'),
                                        aspect: $t('global.form.pictureinput.aspect')
                                    }"
                                    @change="onPhotoSelect"
                                    @error="handlePhotoError"
                            >
                            </PhotoInput>
                        </div>
                    </form>
                </UiCard>   
            </div>

        </div>
        <Toolbar class="flex-row-reverse">
            <Btn class="primary" @click.native.stop="validForm()" v-can="'beepiz-edit-identifications'">{{ $t('global.save') }}</Btn>
            <Btn>
                <router-link to="/parameters/identifications" tag="span">{{ $t('global.cancel') }}</router-link>
            </Btn>
        </Toolbar>
    </div>
</template>

<script>

    import Auth from '@/services/auth.js';
    import API from '@/services/API.js';
    import Utils from '@/services/utils.js';
    import FormUtils from '@/services/form.js';
    import axios from 'axios';
    import Titlebar from "@/components/ui/Titlebar";
    import IDCard from "@/components/identifications/IDCard";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import PhotoInput from '@/components/ui/PictureInput';

    import traductions from '@/services/traductions.js'
    import {useDvFlagAccess} from "../../services/featureFlag";

    var userPlaceholderG = require("@/assets/img/user-no-img.png");

    export default {
        name: 'IdentificationsHome',
        components: {
            Titlebar,
            IDCard,
            Toolbar,
            Btn,
            UiCard,
            PhotoInput
        },
        computed: {
            pageTitle: function(){
                if(this.editMode){
                    return this.identification.name;
                }
                else{
                    return Utils.t('identification.titles.new')
                }
            },
            languages: function(){
                var lsLocale = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_LOCALE');
                if(!lsLocale){
                    lsLocale = 'fr'
                }
                return traductions[lsLocale].languages
            }
        },
        data: () => ({
                userPlaceholder: userPlaceholderG,
                editMode: false,
                identification: {
                    id: null,
                    picture: '',
                    serial: '',
                    language: null,
                    name: '',
                    comment: '',
                },
                showErrors: {
                    picture: false,
                    serial: false,
                    language: false,
                    name: false,
                    comment: false,
                }
            }
        ),
        methods: {
            onPhotoSelect: function(){
                this.identification.picture = this.$refs.IDPhoto.image;
            },
            validForm: function(){
                FormUtils.hideAllErrors(this);
                this.$validator.validateAll().then(() => {
                    this.saveForm();
                }).catch((error) => {
                    FormUtils.showAllErrors(this);
                });
            },
            saveForm: function(){
                window.Vfc.$refs.loading.show();
                var identification = this.identification;

                if(identification.language == 'null'){
                    identification.language = null
                }

                if(this.$route.meta.specialAction == 'copy' || !this.editMode)
                {
                    delete identification.id;
                    axios.post(API.endpoints.identifications.add, identification)
                        .then(response => {
                            window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                            window.V._router.push('/parameters/identifications');
                        })
                        .catch(error => {
                          if (error.response != null) {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    FormUtils.handleErrors(errorBag, error.response.data.message)
                                }
                                FormUtils.showAllErrors(this);
                            }
                            else {
                            }

                            window.Vfc.$refs.loading.hide();
                        })
                }
                else{
                    axios.put(API.route(API.endpoints.identifications.edit, {id: this.$route.params.id}), identification)
                        .then(response => {
                            window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                            window.V._router.push('/parameters/identifications');
                        })
                        .catch(error => {
                            if (error.response != null) {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                  window.Vfc.$refs.messages.sendMessage('error', Utils.t('module.identifications.error.'+error.response.data.message));
                                }
                                FormUtils.showAllErrors(this);
                            }
                            else {
                            }
                            window.Vfc.$refs.loading.hide();
                        })
                }

            },
            hideError: function (key) {
                FormUtils.hideError(this, key);
            },
            handlePhotoError: function(response){
                window.Vfc.$refs.messages.sendMessage('error', response.message);
            }
        },
        created(){
            if(!this.$route.meta.specialAction && this.$route.params.id){
                this.editMode = true;
            }
        },
        mounted(){
            if(!useDvFlagAccess('beepiz-identifications-can:create')){
              this.$router.push({ name: 'AccessDenied', params: { slug: "identifications_no_role"} })
            }

            if(this.$route.params && this.$route.params.id){
                axios.get(API.route(API.endpoints.identifications.show, {id: this.$route.params.id}))
                    .then(response => {
                        this.identification = response.data;
                        if(this.identification.picture) {
                            this.identification.picture = this.identification.picture[0]
                        }
                        if(this.$route.meta.specialAction == 'copy' || !this.editMode)
                        {
                            this.identification.serial = '';
                        }
                        window.Vfc.$refs.loading.hide();
                    })
                    .catch(error => {
                        if (error.response != null) {
                        }
                        else {
                        }
                        window.Vfc.$refs.loading.hide();
                    })
            }
            else{
                window.Vfc.$refs.loading.hide();
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
